module.exports = {
  "scale": {
    "scaleType": "量表类型",
    "questionsNumber": "共{0}题",
    "questionsNumber2": "共{0}道题目",
    minuteDuration: "预计作答{0}分钟",
    "required": "必填",
    "multiple": "多选",
    "scaleDescription": "量表说明",
    "scaleIntroduction": "量表简介",
    "startEvaluation": "开始测评",
    "evaluation": "测评",
    "schedule": "进度",
    "submitErrorHint": "还有{0}道必填题目未完成，请完成后再提交",
    "submitHint": "测评提交成功",
    "scaleErrorHint": "当前测评的状态已经不可以填写",
    "guide": "引导语",
    "scaleSource": "量表出处",
    testIntro: "测试说明"
  },
}



// WEBPACK FOOTER //
// ./src/i18n/scale/zh-CN.js